export interface TldListItem {
  tld: string;
  name: string;
}

export const TLD_LIST: TldListItem[] = [
  { tld: ".ac", name: "Ascension Island" },
  { tld: ".ad", name: "Andorra" },
  { tld: ".ae", name: "United Arab Emirates" },
  { tld: ".af", name: "Afghanistan" },
  { tld: ".ag", name: "Antigua and Barbuda" },
  { tld: ".ai", name: "Anguilla" },
  { tld: ".al", name: "Albania" },
  { tld: ".am", name: "Armenia" },
  { tld: ".ao", name: "Angola" },
  { tld: ".aq", name: "Antarctica" },
  { tld: ".ar", name: "Argentina" },
  { tld: ".as", name: "American Samoa" },
  { tld: ".at", name: "Austria" },
  { tld: ".au", name: "Australia" },
  { tld: ".aw", name: "Aruba" },
  { tld: ".ax", name: "Aland Islands" },
  { tld: ".az", name: "Azerbaijan" },
  { tld: ".ba", name: "Bosnia and Herzegovina" },
  { tld: ".bb", name: "Barbados" },
  { tld: ".bd", name: "Bangladesh" },
  { tld: ".be", name: "Belgium" },
  { tld: ".bf", name: "Burkina Faso" },
  { tld: ".bg", name: "Bulgaria" },
  { tld: ".bh", name: "Bahrain" },
  { tld: ".bi", name: "Burundi" },
  { tld: ".bj", name: "Benin" },
  { tld: ".bm", name: "Bermuda" },
  { tld: ".bn", name: "Brunei" },
  { tld: ".bo", name: "Bolivia" },
  { tld: ".bq", name: "Bonaire" },
  { tld: ".br", name: "Brazil" },
  { tld: ".bs", name: "Bahamas" },
  { tld: ".bt", name: "Bhutan" },
  { tld: ".bw", name: "Botswana" },
  { tld: ".by", name: "Belarus" },
  { tld: ".bz", name: "Belize" },
  { tld: ".ca", name: "Canada" },
  { tld: ".cc", name: "Cocos Islands" },
  { tld: ".cd", name: "Democratic Republic of the Congo" },
  { tld: ".cf", name: "Central African Republic" },
  { tld: ".cg", name: "Republic of the Congo" },
  { tld: ".ch", name: "Switzerland" },
  { tld: ".ci", name: "Cote d'Ivoire (Ivory Coast)" },
  { tld: ".ck", name: "Cook Islands" },
  { tld: ".cl", name: "Chile" },
  { tld: ".cm", name: "Cameroon" },
  { tld: ".cn", name: "China" },
  { tld: ".co", name: "Colombia" },
  { tld: ".cr", name: "Costa Rica" },
  { tld: ".cu", name: "Cuba" },
  { tld: ".cv", name: "Cape Verde" },
  { tld: ".cw", name: "Curacao" },
  { tld: ".cx", name: "Christmas Island" },
  { tld: ".cy", name: "Cyprus" },
  { tld: ".cz", name: "Czech Republic (Czechia)" },
  { tld: ".de", name: "Germany" },
  { tld: ".dj", name: "Djibouti" },
  { tld: ".dk", name: "Denmark" },
  { tld: ".dm", name: "Dominica" },
  { tld: ".do", name: "Dominican Republic" },
  { tld: ".dz", name: "Algeria" },
  { tld: ".ec", name: "Ecuador" },
  { tld: ".ee", name: "Estonia" },
  { tld: ".eg", name: "Egypt" },
  { tld: ".eh", name: "Western Sahara" },
  { tld: ".er", name: "Eritrea" },
  { tld: ".es", name: "Spain" },
  { tld: ".et", name: "Ethiopia" },
  { tld: ".fi", name: "Finland" },
  { tld: ".fj", name: "Fiji" },
  { tld: ".fk", name: "Falkland Islands" },
  { tld: ".fm", name: "Micronesia" },
  { tld: ".fo", name: "Faroe Islands" },
  { tld: ".fr", name: "France" },
  { tld: ".ga", name: "Gabon" },
  { tld: ".gd", name: "Grenada" },
  { tld: ".ge", name: "Georgia" },
  { tld: ".gf", name: "French Guiana" },
  { tld: ".gg", name: "Guernsey" },
  { tld: ".gh", name: "Ghana" },
  { tld: ".gi", name: "Gibraltar" },
  { tld: ".gl", name: "Greenland" },
  { tld: ".gm", name: "Gambia" },
  { tld: ".gn", name: "Guinea" },
  { tld: ".gp", name: "Guadeloupe" },
  { tld: ".gq", name: "Equatorial Guinea" },
  { tld: ".gr", name: "Greece" },
  { tld: ".gs", name: "South Georgia" },
  { tld: ".gt", name: "Guatemala" },
  { tld: ".gu", name: "Guam" },
  { tld: ".gw", name: "Guinea-Bissau" },
  { tld: ".gy", name: "Guyana" },
  { tld: ".hk", name: "Hong Kong" },
  { tld: ".hm", name: "Heard and McDonald Islands" },
  { tld: ".hn", name: "Honduras" },
  { tld: ".hr", name: "Croatia" },
  { tld: ".ht", name: "Haiti" },
  { tld: ".hu", name: "Hungary" },
  { tld: ".id", name: "Indonesia" },
  { tld: ".ie", name: "Ireland" },
  { tld: ".il", name: "Israel" },
  { tld: ".im", name: "Isle of Man" },
  { tld: ".in", name: "India" },
  { tld: ".io", name: "British Indian Ocean Territory" },
  { tld: ".iq", name: "Iraq" },
  { tld: ".ir", name: "Iran" },
  { tld: ".is", name: "Iceland" },
  { tld: ".it", name: "Italy" },
  { tld: ".je", name: "Jersey" },
  { tld: ".jm", name: "Jamaica" },
  { tld: ".jo", name: "Jordan" },
  { tld: ".jp", name: "Japan" },
  { tld: ".ke", name: "Kenya" },
  { tld: ".kg", name: "Kyrgyzstan" },
  { tld: ".kh", name: "Cambodia" },
  { tld: ".ki", name: "Kiribati" },
  { tld: ".km", name: "Comoros" },
  { tld: ".kn", name: "Saint Kitts and Nevis" },
  { tld: ".kp", name: "North Korea" },
  { tld: ".kr", name: "South Korea" },
  { tld: ".kw", name: "Kuwait" },
  { tld: ".ky", name: "Cayman Islands" },
  { tld: ".kz", name: "Kazakhstan" },
  { tld: ".la", name: "Laos" },
  { tld: ".lb", name: "Lebanon" },
  { tld: ".lc", name: "Saint Lucia" },
  { tld: ".li", name: "Liechtenstein" },
  { tld: ".lk", name: "Sri Lanka" },
  { tld: ".lr", name: "Liberia" },
  { tld: ".ls", name: "Lesotho" },
  { tld: ".lt", name: "Lithuania" },
  { tld: ".lu", name: "Luxembourg" },
  { tld: ".lv", name: "Latvia" },
  { tld: ".ly", name: "Libya" },
  { tld: ".ma", name: "Morocco" },
  { tld: ".mc", name: "Monaco" },
  { tld: ".md", name: "Moldova" },
  { tld: ".me", name: "Montenegro" },
  { tld: ".mg", name: "Madagascar" },
  { tld: ".mh", name: "Marshall Islands" },
  { tld: ".mk", name: "North Macedonia" },
  { tld: ".ml", name: "Mali" },
  { tld: ".mm", name: "Myanmar (Burma)" },
  { tld: ".mn", name: "Mongolia" },
  { tld: ".mo", name: "Macau" },
  { tld: ".mp", name: "Northern Mariana Islands" },
  { tld: ".mq", name: "Martinique" },
  { tld: ".mr", name: "Mauritania" },
  { tld: ".ms", name: "Montserrat" },
  { tld: ".mt", name: "Malta" },
  { tld: ".mu", name: "Mauritius" },
  { tld: ".mv", name: "Maldives" },
  { tld: ".mw", name: "Malawi" },
  { tld: ".mx", name: "Mexico" },
  { tld: ".my", name: "Malaysia" },
  { tld: ".mz", name: "Mozambique" },
  { tld: ".na", name: "Namibia" },
  { tld: ".nc", name: "New Caledonia" },
  { tld: ".ne", name: "Niger" },
  { tld: ".nf", name: "Norfolk Island" },
  { tld: ".ng", name: "Nigeria" },
  { tld: ".ni", name: "Nicaragua" },
  { tld: ".nl", name: "Netherlands" },
  { tld: ".no", name: "Norway" },
  { tld: ".np", name: "Nepal" },
  { tld: ".nr", name: "Nauru" },
  { tld: ".nu", name: "Niue" },
  { tld: ".nz", name: "New Zealand" },
  { tld: ".om", name: "Oman" },
  { tld: ".pa", name: "Panama" },
  { tld: ".pe", name: "Peru" },
  { tld: ".pf", name: "French Polynesia" },
  { tld: ".pg", name: "Papua New Guinea" },
  { tld: ".ph", name: "Philippines" },
  { tld: ".pk", name: "Pakistan" },
  { tld: ".pl", name: "Poland" },
  { tld: ".pm", name: "Saint Pierre and Miquelon" },
  { tld: ".pn", name: "Pitcairn Islands" },
  { tld: ".pr", name: "Puerto Rico" },
  { tld: ".ps", name: "Palestine" },
  { tld: ".pt", name: "Portugal" },
  { tld: ".pw", name: "Palau" },
  { tld: ".py", name: "Paraguay" },
  { tld: ".qa", name: "Qatar" },
  { tld: ".re", name: "Reunion" },
  { tld: ".ro", name: "Romania" },
  { tld: ".rs", name: "Serbia" },
  { tld: ".ru", name: "Russia" },
  { tld: ".rw", name: "Rwanda" },
  { tld: ".sa", name: "Saudi Arabia" },
  { tld: ".sb", name: "Solomon Islands" },
  { tld: ".sc", name: "Seychelles" },
  { tld: ".sd", name: "Sudan" },
  { tld: ".se", name: "Sweden" },
  { tld: ".sg", name: "Singapore" },
  { tld: ".sh", name: "Saint Helena" },
  { tld: ".si", name: "Slovenia" },
  { tld: ".sj", name: "Svalbard and Jan Mayen" },
  { tld: ".sk", name: "Slovakia" },
  { tld: ".sl", name: "Sierra Leone" },
  { tld: ".sm", name: "San Marino" },
  { tld: ".sn", name: "Senegal" },
  { tld: ".so", name: "Somalia" },
  { tld: ".sr", name: "Suriname" },
  { tld: ".ss", name: "South Sudan" },
  { tld: ".st", name: "Sao Tome and Principe" },
  { tld: ".sv", name: "El Salvador" },
  { tld: ".sx", name: "Sint Maarten" },
  { tld: ".sy", name: "Syria" },
  { tld: ".sz", name: "Eswatini (Swaziland)" },
  { tld: ".tc", name: "Turks and Caicos Islands" },
  { tld: ".td", name: "Chad" },
  { tld: ".tf", name: "French Southern Territories" },
  { tld: ".tg", name: "Togo" },
  { tld: ".th", name: "Thailand" },
  { tld: ".tj", name: "Tajikistan" },
  { tld: ".tk", name: "Tokelau" },
  { tld: ".tl", name: "Timor-Leste (East Timor)" },
  { tld: ".tm", name: "Turkmenistan" },
  { tld: ".tn", name: "Tunisia" },
  { tld: ".to", name: "Tonga" },
  { tld: ".tr", name: "Turkey (Turkiye)" },
  { tld: ".tt", name: "Trinidad and Tobago" },
  { tld: ".tv", name: "Tuvalu" },
  { tld: ".tw", name: "Taiwan" },
  { tld: ".tz", name: "Tanzania" },
  { tld: ".ua", name: "Ukraine" },
  { tld: ".ug", name: "Uganda" },
  { tld: ".uk", name: "United Kingdom" },
  { tld: ".us", name: "United States" },
  { tld: ".uy", name: "Uruguay" },
  { tld: ".uz", name: "Uzbekistan" },
  { tld: ".va", name: "Vatican City" },
  { tld: ".vc", name: "Saint Vincent and the Grenadines" },
  { tld: ".ve", name: "Venezuela" },
  { tld: ".vg", name: "British Virgin Islands" },
  { tld: ".vi", name: "US Virgin Islands" },
  { tld: ".vn", name: "Vietnam" },
  { tld: ".vu", name: "Vanuatu" },
  { tld: ".wf", name: "Wallis and Futuna" },
  { tld: ".ws", name: "Samoa" },
  { tld: ".ye", name: "Yemen" },
  { tld: ".yt", name: "Mayotte" },
  { tld: ".za", name: "South Africa" },
  { tld: ".zm", name: "Zambia" },
  { tld: ".zw", name: "Zimbabwe" },
  { tld: ".ac.uk", name: "United Kingdom - Academic" },
  { tld: ".co.il", name: "Israel" },
  { tld: ".co.in", name: "India" },
  { tld: ".co.jp", name: "Japan" },
  { tld: ".co.kr", name: "South Korea" },
  { tld: ".co.nz", name: "New Zealand" },
  { tld: ".co.uk", name: "United Kingdom" },
  { tld: ".co.za", name: "South Africa" },
  { tld: ".com.ar", name: "Argentina" },
  { tld: ".com.au", name: "Australia" },
  { tld: ".com.br", name: "Brazil" },
  { tld: ".com.cn", name: "China" },
  { tld: ".com.hk", name: "Hong Kong" },
  { tld: ".com.mx", name: "Mexico" },
  { tld: ".com.ng", name: "Nigeria" },
  { tld: ".com.pk", name: "Pakistan" },
  { tld: ".com.ru", name: "Russia" },
  { tld: ".com.sg", name: "Singapore" },
  { tld: ".com.tr", name: "Turkey (Turkiye)" },
  { tld: ".com.tw", name: "Taiwan" },
  { tld: ".com.ua", name: "Ukraine" },
  { tld: ".edu.au", name: "Australia - Education" },
  { tld: ".go.jp", name: "Japan - Government" },
  { tld: ".gov.au", name: "Australia - Government" },
  { tld: ".gov.uk", name: "United Kingdom - Government" },
  { tld: ".me.uk", name: "United Kingdom" },
  { tld: ".ne.jp", name: "Japan" },
  { tld: ".net.au", name: "Australia" },
  { tld: ".or.jp", name: "Japan" },
  { tld: ".org.au", name: "Australia" },
  { tld: ".org.uk", name: "United Kingdom" },
  { tld: ".eu", name: "European Union (27 countries)" },
  { tld: ".asia", name: "Asia-Pacific region (multi-country)" },
  { tld: ".lat", name: "Latin America region" },
  { tld: ".com", name: "Commercial - largest global TLD" },
  { tld: ".net", name: "Network / infrastructure providers" },
  { tld: ".org", name: "Organizations, non-profits, NGOs" },
  { tld: ".info", name: "Information services" },
  { tld: ".biz", name: "Business entities" },
  { tld: ".company", name: "Companies" },
  { tld: ".inc", name: "Incorporated companies" },
  { tld: ".ltd", name: "Limited companies" },
  { tld: ".llc", name: "Limited liability companies" },
  { tld: ".gmbh", name: "German limited companies" },
  { tld: ".store", name: "Online stores / retail" },
  { tld: ".shop", name: "Shopping / e-commerce" },
  { tld: ".shopping", name: "Shopping" },
  { tld: ".sale", name: "Sales / promotions" },
  { tld: ".deals", name: "Deals / discounts" },
  { tld: ".market", name: "Marketplaces" },
  { tld: ".markets", name: "Markets" },
  { tld: ".buy", name: "Purchasing" },
  { tld: ".business", name: "Business" },
  { tld: ".enterprises", name: "Enterprises" },
  { tld: ".industries", name: "Industries" },
  { tld: ".global", name: "Global businesses" },
  { tld: ".world", name: "Global / general" },
  { tld: ".international", name: "International businesses" },
  { tld: ".brands", name: "Brands" },
  { tld: ".ngo", name: "Non-governmental organizations" },
  { tld: ".ong", name: "Non-governmental organizations (intl.)" },
  { tld: ".foundation", name: "Foundations / charities" },
  { tld: ".charity", name: "Charities" },
  { tld: ".community", name: "Communities" },
  { tld: ".club", name: "Clubs / groups" },
  { tld: ".team", name: "Teams" },
  { tld: ".church", name: "Churches / religious orgs" },
  { tld: ".gives", name: "Charitable giving" },
  { tld: ".dev", name: "Developers / software" },
  { tld: ".app", name: "Applications / SaaS" },
  { tld: ".tech", name: "Technology companies" },
  { tld: ".cloud", name: "Cloud services" },
  { tld: ".software", name: "Software" },
  { tld: ".systems", name: "IT systems" },
  { tld: ".network", name: "Networking" },
  { tld: ".digital", name: "Digital services" },
  { tld: ".online", name: "Online services" },
  { tld: ".site", name: "Websites" },
  { tld: ".website", name: "Websites" },
  { tld: ".web", name: "Web" },
  { tld: ".host", name: "Web hosting" },
  { tld: ".hosting", name: "Web hosting" },
  { tld: ".server", name: "Servers" },
  { tld: ".domains", name: "Domain services" },
  { tld: ".codes", name: "Code / programming" },
  { tld: ".computer", name: "Computing" },
  { tld: ".data", name: "Data services" },
  { tld: ".tools", name: "Tools / utilities" },
  { tld: ".api", name: "APIs" },
  { tld: ".click", name: "Click / redirect (often abused)" },
  { tld: ".link", name: "Links / redirects (often abused)" },
  { tld: ".download", name: "Downloads (often abused)" },
  { tld: ".zip", name: "Files / archives (often abused)" },
  { tld: ".mov", name: "Video files (often abused)" },
  { tld: ".media", name: "Media companies" },
  { tld: ".news", name: "News outlets" },
  { tld: ".press", name: "Press / publishing" },
  { tld: ".blog", name: "Blogs" },
  { tld: ".video", name: "Video" },
  { tld: ".film", name: "Film industry" },
  { tld: ".movie", name: "Movies" },
  { tld: ".music", name: "Music" },
  { tld: ".radio", name: "Radio" },
  { tld: ".games", name: "Games / gaming" },
  { tld: ".game", name: "Gaming" },
  { tld: ".live", name: "Live streaming / events" },
  { tld: ".studio", name: "Studios" },
  { tld: ".photography", name: "Photography" },
  { tld: ".photo", name: "Photos" },
  { tld: ".art", name: "Art / creative" },
  { tld: ".design", name: "Design" },
  { tld: ".gallery", name: "Galleries" },
  { tld: ".pro", name: "Licensed professionals" },
  { tld: ".consulting", name: "Consulting" },
  { tld: ".management", name: "Management" },
  { tld: ".agency", name: "Agencies" },
  { tld: ".services", name: "Services" },
  { tld: ".solutions", name: "Solutions providers" },
  { tld: ".partners", name: "Partnerships" },
  { tld: ".ventures", name: "Ventures / startups" },
  { tld: ".works", name: "Works / services" },
  { tld: ".careers", name: "Careers / recruitment" },
  { tld: ".jobs", name: "Job portals / recruitment" },
  { tld: ".law", name: "Legal / law firms" },
  { tld: ".legal", name: "Legal services" },
  { tld: ".attorney", name: "Attorneys" },
  { tld: ".accountant", name: "Accountants" },
  { tld: ".accountants", name: "Accountants" },
  { tld: ".tax", name: "Tax services" },
  { tld: ".engineer", name: "Engineers" },
  { tld: ".engineering", name: "Engineering" },
  { tld: ".construction", name: "Construction" },
  { tld: ".contractors", name: "Contractors" },
  { tld: ".marketing", name: "Marketing" },
  { tld: ".training", name: "Training" },
  { tld: ".expert", name: "Experts / specialists" },
  { tld: ".associates", name: "Associates" },
  { tld: ".finance", name: "Finance" },
  { tld: ".financial", name: "Financial services" },
  { tld: ".bank", name: "Banks (restricted-registration)" },
  { tld: ".insurance", name: "Insurance" },
  { tld: ".money", name: "Money / payments" },
  { tld: ".cash", name: "Cash / payments" },
  { tld: ".fund", name: "Funds / investment" },
  { tld: ".capital", name: "Capital / investment" },
  { tld: ".investments", name: "Investments" },
  { tld: ".exchange", name: "Exchanges" },
  { tld: ".loans", name: "Loans" },
  { tld: ".credit", name: "Credit" },
  { tld: ".creditcard", name: "Credit cards" },
  { tld: ".insure", name: "Insurance" },
  { tld: ".trading", name: "Trading" },
  { tld: ".crypto", name: "Cryptocurrency" },
  { tld: ".academy", name: "Academies / education" },
  { tld: ".school", name: "Schools" },
  { tld: ".college", name: "Colleges" },
  { tld: ".university", name: "Universities" },
  { tld: ".education", name: "Education" },
  { tld: ".institute", name: "Institutes" },
  { tld: ".science", name: "Science" },
  { tld: ".health", name: "Health services" },
  { tld: ".healthcare", name: "Healthcare" },
  { tld: ".clinic", name: "Clinics" },
  { tld: ".doctor", name: "Doctors" },
  { tld: ".dental", name: "Dental" },
  { tld: ".care", name: "Care services" },
  { tld: ".fitness", name: "Fitness" },
  { tld: ".name", name: "Personal names" },
  { tld: ".life", name: "Lifestyle" },
  { tld: ".family", name: "Family" },
  { tld: ".home", name: "Home" },
  { tld: ".house", name: "Real estate / home" },
  { tld: ".realestate", name: "Real estate" },
  { tld: ".properties", name: "Property" },
  { tld: ".realty", name: "Realty" },
  { tld: ".travel", name: "Travel industry" },
  { tld: ".vacations", name: "Vacations" },
  { tld: ".flights", name: "Flights" },
  { tld: ".hotel", name: "Hotels" },
  { tld: ".hotels", name: "Hotels" },
  { tld: ".restaurant", name: "Restaurants" },
  { tld: ".food", name: "Food" },
  { tld: ".cafe", name: "Cafes" },
  { tld: ".bar", name: "Bars" },
  { tld: ".fashion", name: "Fashion" },
  { tld: ".style", name: "Style" },
  { tld: ".beauty", name: "Beauty" },
  { tld: ".fun", name: "Entertainment / leisure" },
  { tld: ".dating", name: "Dating" },
  { tld: ".social", name: "Social" },
  { tld: ".wedding", name: "Weddings" },
  { tld: ".guru", name: "General / expert" },
  { tld: ".xyz", name: "Generic (popular, often abused)" },
  { tld: ".top", name: "Generic (often abused)" },
  { tld: ".vip", name: "VIP / premium" },
  { tld: ".pizza", name: "Pizza / food" },
  { tld: ".email", name: "Email services" },
  { tld: ".edu", name: "US educational institutions (sponsored)" },
  { tld: ".gov", name: "US government (sponsored)" },
  { tld: ".mil", name: "US military (sponsored)" },
  { tld: ".int", name: "International treaty organizations (UN, NATO, WHO)" },
  { tld: ".aero", name: "Aviation / aerospace industry (sponsored)" },
  { tld: ".coop", name: "Cooperatives (sponsored)" },
  { tld: ".museum", name: "Museums (sponsored)" },
  { tld: ".post", name: "Postal / logistics services (sponsored)" },
  { tld: ".tel", name: "Telecom contact data (sponsored)" },
  { tld: ".mobi", name: "Mobile-optimized sites" },
  { tld: ".arpa", name: "Internet infrastructure (technical, IANA)" },
  { tld: ".onion", name: "Tor hidden services (special-use)" },
];
